
































import { Component, Vue } from 'vue-property-decorator';
import { APP_NAMESPACES } from '@/_core/store/namespaces';
import { IUser } from '@/_core/models/user.model';
import { IActorRoleSetting } from '@/_core/models/actor-role-setting.model';
import ClTabs from '@/_shared/components/cl-tabs/cl-tabs.vue';
import ClTab from '@/_shared/components/cl-tabs/cl-tab.vue';
import ActorDesireForm from '@/modules/actor/resume/components/actor-desire-form/actor-desire-form.vue';
import { AuthActionsTypes } from '@/_core/store/auth/types';

@Component({
  name: 'actor-desired-projects',
  components: { ClTabs, ClTab, ActorDesireForm },
})
export default class ActorDesiredProjects extends Vue {
  @APP_NAMESPACES.auth.Getter('user') user!: IUser;
  @APP_NAMESPACES.auth.Getter('updateLoading') updateLoading!: boolean;
  @APP_NAMESPACES.auth.Getter('roleSetting') roleSetting!: IActorRoleSetting[];

  @APP_NAMESPACES.auth.Action(AuthActionsTypes.UPDATE_USER) updateUser: (
    data: Partial<IUser>
  ) => void;

  public getBySetting(type: string) {
    return this.roleSetting.filter((s) => s.type === type);
  }
}
